import React from 'react';

// utils
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

// Components

// Styles
import styles from './styles';
import ADGMAcknowledgementPopup from '../ADGMAcknowledgementPopup';

function CancelApplicationModalV2(props) {
  // eslint-disable-next-line no-unused-vars
  const { onClose, open, cancelApplication, classes } = props;

  return (
    <ADGMAcknowledgementPopup
      open={open}
      title='cancel_application'
      description='drc_application_cancel_warning_message'
      cancelBtnText='discard'
      proceedBtnText='confirm'
      onCloseHandler={onClose}
      onCancelHandler={onClose}
      onProceedHandler={() => {
        onClose();
        cancelApplication();
      }}
    />
  );
}

CancelApplicationModalV2.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  cancelApplication: PropTypes.func.isRequired,
};
export default withStyles(styles)(CancelApplicationModalV2);
